export default () => ({

    swiper: null,

    /**
     * Для инициализации слайдера
     * используется аттрибут `x-intersect.once="initSlider"`
     */
    initSlider() {

        // noinspection JSUnresolvedReference
        this.swiper = new Swiper(this.$root.querySelector('.swiper'), {
            slidesPerView: 1,
            loop: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            virtualTranslate: true,
            speed: 1000,
            autoplay: {
                delay: 5000,
                pauseOnMouseEnter: true,
                stopOnLastSlide: false,
                disableOnInteraction: true,
                waitForTransition: true,
            },
            a11y: {
                enabled: true,
                slideRole: 'group',
                notificationClass: 'sr-only',
                scrollOnFocus: true,
            }
        });
    }
});
